<!--
 * @Author: Hyman Choi
 * @Date: 2020-12-24 15:14:01
 * @LastEditTime: 2020-12-28 10:29:21
 * @LastEditors: Hyman Choi
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.Web\src\views\userSetting\authentication\index.vue
-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-button size="small" type="primary" @click.stop="goBack()">
        返回
      </el-button>
    </el-card>

    <el-card class="box-card">
      <el-form
        ref="form"
        :model="form"
        label-width="120px"
        style="margin-top: 20px"
      >
        <el-form-item label="姓">
          <el-input v-model="form.row1" style="width: 400px" />
        </el-form-item>
        <el-form-item label="名字">
          <el-input v-model="form.row2" style="width: 400px" />
        </el-form-item>
        <el-form-item label="医院名">
          <el-input v-model="form.row3" style="width: 400px" />
        </el-form-item>
        <el-form-item label="科室">
          <el-select v-model="form.region" style="width: 400px">
            <el-option label="区域一" value="shanghai" />
            <el-option label="区域二" value="beijing" />
          </el-select>
        </el-form-item>
        <el-form-item label="专家头衔">
          <el-select v-model="form.region" style="width: 400px">
            <el-option label="区域一" value="shanghai" />
            <el-option label="区域二" value="beijing" />
          </el-select>
        </el-form-item>
        <el-form-item label="职务">
          <el-input v-model="form.row3" style="width: 400px" />
        </el-form-item>
        <el-form-item label="擅长领域">
          <el-input v-model="form.row3" style="width: 400px" />
        </el-form-item>
        <el-form-item label="简介">
          <el-input
            v-model="form.row3"
            type="textarea"
            rows="3"
            style="width: 400px"
          />
        </el-form-item>
        <el-form-item label="所属领域">
          <el-select v-model="form.region" style="width: 400px">
            <el-option label="区域一" value="shanghai" />
            <el-option label="区域二" value="beijing" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary"> 提交申请 </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        row1: '',
        row2: '',
        row3: ''
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
